import React, { useState, useContext, useEffect } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import TheUserImg from "../../images/thimg.png";

import StarRatings from "react-star-ratings";
import Icon1 from "../../images/theraicon1.svg";
import Icon2 from "../../images/theraicon2.svg";
import Icon3 from "../../images/theraicon3.svg";
import Icon4 from "../../images/dollar.svg";
import Icon5 from "../../images/clock.svg";
import Button from "react-bootstrap/Button";
import { Link, useParams, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { FaAlignLeft } from "react-icons/fa";
import TherapistSidebar from "../../inc/TherapistSidebar";
import Functions from "../../../utility/services/Functions";
import { AuthContext } from "../../../utility/services/AuthContext";
import ConstConfig from "../../../utility/configs/constConfig";
import { toast } from "react-toastify";
import ApiService from "../../../utility/services/ApiService";
import ImageConfig from "../../../utility/configs/imageConfig";
import ReactStarsRating from "react-awesome-stars-rating";
import { FiAlertCircle } from "react-icons/fi";
import Modal from "react-bootstrap/Modal";
import UserAvatar from "../../common/UserAvatar";

const PatientAppointmentDetail = () => {
  // LOGICAL FUNCTIONS
  const booking_id = useParams().id;
  const { setLoading } = useContext(AuthContext);
  const {
    get_therapist_full_details_for_patient,
    get_patient_specific_booking_details,
    add_rating,
  } = ApiService();
  const {
    consoleService,
    formet_date,
    formet_time,
    scheduledTimeForTherapist,
    getStars,
  } = Functions();
  const navigate = useNavigate();

  const [filterHideShow, setfilterHideShow] = useState(false);

  // DATA VARIABLES

  const [bookingDetails, setBookingDetails] = useState({});
  const [therapistDetails, setTherapistDetails] = useState({});
  const [rating, setRating] = useState(0);
  const [reviews, setReviews] = useState("");

  const [showPriceDetailsModal, setShowPriceDetailsModal] = useState(false);

  const togglePriceDetailsModal = () => {
    setShowPriceDetailsModal(!showPriceDetailsModal);
  };

  // USE EFFECTS

  useEffect(() => {
    fetch_initial_details();
  }, []);

  // FUNCTIONS

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const res = await get_patient_specific_booking_details(booking_id);

      if (res.status === 1) {
        setBookingDetails(res.data);
        setTherapistDetails(res.data.therapist_details || {});
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_initial_details", err);
    }
  }

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  const handleBookAgain = async () => {
    setLoading(true);
    try {
      const res = await get_therapist_full_details_for_patient(
        bookingDetails.therapist_details._id
      );

      if (res.status === 1) {
        setLoading(false);
        navigate("/bookanappointment", {
          state: { therapistDetails: res.data },
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in handleBookAgain function", err);
    }
  };

  const submitReview = async () => {
    setLoading(true);
    try {
      if (rating > 0) {
        const data = {
          booking_id: bookingDetails.booking_id,
          rating_receipent_id: therapistDetails._id,
          rating: rating,
          reviews: reviews ? reviews : "",
        };
        const res = await add_rating(data);
        if (res.status === 1) {
          setLoading(false);
          fetch_initial_details();
        } else {
          setLoading(false);
          consoleService("Error in submitReview function", res.message);
        }
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in submitReview function", err);
    }
  };

  // COUPON MODAL

  function PriceDetailsModal(props) {
    const bookingDetails = props.booking_details;
    const calculated_discount = (() => {
      let Price = Number(bookingDetails.price);
      let Paid_price = Number(bookingDetails.patient_paid_price);
      let discount = Price - Paid_price;
      return discount;
    })();

    return (
      <Modal
        {...props}
        size="md"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="discount_des discount_des2">
            <div>
              <span>Price</span>
              <span>${bookingDetails.price}</span>
            </div>
            <div>
              <span>Discount</span>
              <span>- ${calculated_discount}</span>
            </div>
            <hr />
            <div>
              <span>Total</span>
              <span>${bookingDetails.patient_paid_price}</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection
          banner={Banner}
          name={"Home"}
          title={"Appointment Detail"}
        />
      </div>
      <section className="py-5 useraccount bg-light_dash detailsBox ">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>

            <div className="col-xl-9 col-md-8 fulltabBox patient_appointment_details_box">
              <div className="filterBox">
                <Link className="filterIcon" onClick={sideBarHide}>
                  <FaAlignLeft />
                </Link>
              </div>
              {Object.keys(bookingDetails).length > 0 && (
                <>
                  <div className="flexUser">
                    <div className="userDetails userDetails2">
                      <UserAvatar
                        profileImage={therapistDetails.profile_img}
                        firstName={therapistDetails.first_name || therapistDetails.name}
                        lastName={therapistDetails.last_name}
                        size="xl"
                        className="img-fluid thimg"
                        alt={`${therapistDetails.first_name} ${therapistDetails.last_name} profile`}
                      />
                      <div className="rightflex">
                        <div className="d-flex align-items-center">
                          <img
                            src={Icon1}
                            alt=""
                            className="img-fluid me-2 icc"
                          />
                          <h2 style={{ color: "black" }}>
                            {`${therapistDetails?.first_name || ''} ${therapistDetails?.last_name || ''}`}{" "}
                            {therapistDetails?.online_status ? (
                              <span
                                className="online"
                                style={{ backgroundColor: "#4CD964" }}
                              ></span>
                            ) : (
                              <span
                                className="online"
                                style={{ backgroundColor: "#9E9E9E" }}
                              ></span>
                            )}
                          </h2>
                        </div>

                        <div className="d-flex align-items-center mb-3 mt-1">
                          <img
                            src={Icon2}
                            alt=""
                            className="img-fluid me-2 icc"
                          />
                          <div>
                            {bookingDetails.speciality.map((item, index) => {
                              return (
                                <p key={index} className="mb-0">
                                  {item}
                                </p>
                              );
                            })}
                          </div>
                        </div>

                        <div className="d-flex align-items-center mb-3 mt-1">
                          <img
                            src={Icon3}
                            alt=""
                            className="img-fluid me-2 icc"
                          />
                          <p className="mb-0">
                            {formet_date(bookingDetails.time)} |{" "}
                            {formet_time(bookingDetails.time)}
                          </p>
                        </div>

                        <div className="d-flex align-items-center mb-3 mt-1">
                          <img
                            src={Icon4}
                            alt=""
                            className="img-fluid me-2 icc"
                          />
                          <p className="mb-0">
                            {bookingDetails.patient_paid_price != undefined
                              ? bookingDetails.patient_paid_price
                              : bookingDetails.price}{" "}
                            <span
                              onClick={() => {
                                togglePriceDetailsModal();
                              }}
                              style={{
                                position: "relative",
                                top: -2,
                                cursor: "pointer",
                                marginLeft: 20,
                              }}
                            >
                              <FiAlertCircle />
                            </span>
                          </p>
                        </div>

                        <div className="d-flex align-items-center mt-1">
                          <img
                            src={Icon5}
                            alt=""
                            className="img-fluid me-2 icc"
                          />
                          <p className="mb-0">
                            {scheduledTimeForTherapist(
                              bookingDetails.pricing,
                              bookingDetails.pricing_id
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      <Button
                        onClick={() => {
                          handleBookAgain();
                        }}
                        to="/bookanappointment"
                        className="btn btn-primary bookbtn"
                      >
                        Book Again
                      </Button>
                    </div>
                  </div>
                  <section className="py-5 specbox">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          {bookingDetails.reviews.length > 0 ? (
                            <>
                              <h2 className="mb-3">Your Feedback</h2>
                              <div className="stardet">
                                <StarRatings
                                  rating={parseFloat(
                                    Number(
                                      bookingDetails.reviews[0].rating
                                    ).toFixed(1)
                                  )}
                                  starRatedColor="#FF674F"
                                  numberOfStars={5}
                                  name="rating"
                                  starDimension="18px"
                                  starSpacing={0}
                                />

                                <span className="mt-1">
                                  {bookingDetails.reviews[0].rating.toFixed()}
                                </span>
                              </div>
                              <p>{bookingDetails.reviews[0].reviews}</p>
                            </>
                          ) : (
                            <>
                              <h2 className="mb-3">Give Rating</h2>
                              <div
                                className="stardet"
                                style={{ paddingBottom: 10 }}
                              >
                                <ReactStarsRating
                                  onChange={(value) => {
                                    setRating(value);
                                  }}
                                  primaryColor="#FF674F"
                                  value={rating}
                                  isHalf={false}
                                  size={40}
                                />
                              </div>
                              <h2 className="mb-3">Write Your Review</h2>
                              <Form.Control
                                placeholder="Write Your Review"
                                as="textarea"
                                value={reviews}
                                onChange={(e) => {
                                  setReviews(e.target.value);
                                }}
                                rows={3}
                                className="mt-4"
                              />
                              <Button
                                disabled={!(rating > 0)}
                                className="btn btn-primary me-3"
                                onClick={() => {
                                  submitReview();
                                }}
                              >
                                Submit
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      <PriceDetailsModal
        show={showPriceDetailsModal}
        onHide={() => togglePriceDetailsModal()}
        booking_details={bookingDetails}
      />
    </>
  );
};

export default PatientAppointmentDetail;
